import { GRAAL_API_URL } from "../../config";
import { graalApiAxiosInstance } from "../../middlewares/useApiAuthMiddleware";

const useLeadAutoStatusService = () => {
  const leadAutoStatusServiceActions = {
    patchStatus: (leadId, newStatus, reason = {}) => {
      return graalApiAxiosInstance
        .patch(`${GRAAL_API_URL}new-leads/${leadId}/modifier-statut`, {
          statut: newStatus,
          ...reason,
        })
        .then((res) => res.data);
    },
  };

  return { leadAutoStatusServiceActions };
};

export default useLeadAutoStatusService;
